export const API_URL = (import.meta.env && import.meta.env.VITE_API_URL) || 'https://www.prodnook.cl';